import React, { useId } from 'react';
import { Field, FieldError, FieldLabel } from '../../shadcn/components/ui/field';
import PhoneInput from '../../Components/Common/PhoneInput/PhoneInput';

// Labelled auth phone input, like AuthTextField. `onChange` receives the
// number as "+306912345678". `helperText` is the error message.
export default function AuthPhoneField({ label, id, error, helperText, inputProps = {}, ...props }) {
  const generatedId = useId();
  const inputId = id || generatedId;
  const errorId = error && helperText ? `${inputId}-error` : undefined;
  return <Field data-invalid={error ? true : undefined} className="gap-1.5">
    <FieldLabel htmlFor={inputId}>{label}</FieldLabel>
    <PhoneInput {...props} {...inputProps} id={inputId}
      aria-invalid={error ? true : undefined} aria-describedby={errorId} />
    {errorId && <FieldError id={errorId}>{helperText}</FieldError>}
  </Field>;
}
